//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { ExceptionsService } from './exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, of, lastValueFrom, map } from 'rxjs';
@Injectable({ providedIn: 'root' })

export class BooleanService {
  
  constructor(
    private exceptionsService: ExceptionsService
  ) { }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      let booleanData = {
        "booleans": [
          {
            "id"         : false,
            "description": "No"
          },
          {
            "id"         : true,
            "description": "Yes"
          }
        ]
      };
      
      return of(booleanData.booleans)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      )
      ;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(idAndDescription: IdAndDescriptionDTO) {
    return {id: idAndDescription.id, description: idAndDescription.description};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
